import React, { useState } from 'react';

// Styles & Assets
import styles from './BarButtons.module.css';
import { ReactComponent as CalendarSVG } from '../../../assets/icons/calendar.svg';
import { ReactComponent as IconWeek } from '../../../assets/icons/icon-week.svg';
import { ReactComponent as TodaySVG } from '../../../assets/icons/today-sharp.svg';
import { ReactComponent as ChevronRight } from '../../../assets/icons/chevron-right.svg';
import { ReactComponent as PlusSvg } from '../../../assets/icons/+.svg';

// Hooks
import { useTranslation } from 'react-i18next';

// Components
import CalendarViewOption from '../CalendarViewOption/CalendarViewOption';
import Select from '../../UI/Select/Select';
import Modal from '../../UI/Modal/Modal';
import CreateEventDialog from '../CreateEventDialog/CreateEventDialog';

// Interfaces
import { OptionElement } from '../../../interfaces/Input';
interface Props {
    isViewMonthly: boolean
    handleClickToday: () => void
    setIsViewMonthly: React.Dispatch<React.SetStateAction<boolean>>
}

const BarButtons: React.FC<Props> = ({isViewMonthly, handleClickToday, setIsViewMonthly}) => {

    const { t } = useTranslation();

    const [showCreateEvent, setShowCreateEvent] = useState(false);

    const handleChangeView = (option: OptionElement<number>) => {
        setIsViewMonthly(option.id === 0);
    };

    const options: OptionElement<number>[] = [
        { id: 0, label: <CalendarViewOption label={t('monthly_view')} icon={<CalendarSVG />} /> },
        { id: 1, label: <CalendarViewOption label={t('weekly_view')} icon={<IconWeek />} /> }
    ];

    return (
        <div className={styles.containerButtons}>
            <Select
                selector={(props) =>
                    <div className={styles.button}>
                        <CalendarSVG />
                        <p>{isViewMonthly ? t('monthly_view') : t('weekly_view')}</p>
                        <ChevronRight />
                    </div>
                }
                options={options}
                onSelect={handleChangeView}
            />
            {isViewMonthly &&
                <button className={styles.button} onClick={handleClickToday}>
                    <TodaySVG />
                    <p>{t('today')}</p>
                </button>
            }
            <button onClick={() => setShowCreateEvent(true)} className={`${styles.button} ${styles.contrastButton}`}>
                <p>{t('create_appointment')}</p>
                <PlusSvg height={18} />
            </button>
            <Modal show={showCreateEvent} setShowModal={setShowCreateEvent}>
                <CreateEventDialog />
            </Modal>
        </div>
    );
};

export default BarButtons;